import React, { useState } from "react";
import "./Nav.css";
import sitelogo from "../../../Images/logo.png";
import { Link } from "react-router-dom";

import NavSidebar from "./Sidebar/Sidebar";

function Nav() {
  const [respNavActivator, setRespNavActivator] = useState(false);

  // const [navSelectSignle, setNavSelectSignle] = useState("");
  // const [navSelectParent, setNavSelectParent] = useState("");
  // const [navSelectChild, setNavSelectChild] = useState("");

  // const navSelectSignleHandler = () =>{
  //   setNavSelectParent("");
  //   setNavSelectChild("");
  //   setNavSelectSignle("SIngle");
  //   console.log(navSelectSignle);
  // }

  // const setNavSelectParentHandler = () =>{   
  //   setNavSelectChild("");
  //   setNavSelectSignle("");
  //   setNavSelectParent("ParentT");
  //   console.log(navSelectParent);
  // }

  // const setNavSelectChildHandler = () =>{ 
  //   setNavSelectSignle("");
  //   setNavSelectParent("Parent with sub");
  //   setNavSelectChild("CHild with Parent");
  //   console.log(navSelectChild);
  // }

  return (
    <div
      className={`comb-sec nav-sec nav-controller ${
        respNavActivator ? "nav-control-toggler" : ""
      }`}
    >
      <svg
        className="mobNavToggleBTN"
        onClick={() => setRespNavActivator(!respNavActivator)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" />
      </svg>

      <div
        className="sidebar sidebar-dark sidebar-fixed border-end"
        id="sidebar"
      >
        <div className="sidebar-header border-bottom">
          <div className="sidebar-brand">
            <img className="nav-logo" src={sitelogo} />
          </div>
          {/* <button className="btn-close d-lg-none" type="button" data-coreui-dismiss="offcanvas" data-coreui-theme="dark" aria-label="Close"></button> */}
        </div>
       
       <NavSidebar/>

      </div>
    </div>
    // .
  );
}
export default Nav;
